import { Box, Flex, Heading, useMediaQuery } from '@chakra-ui/react';
import { responsiveValue } from '../../../assets/style/defaultTheme';
import { theme } from '../../../assets/style/theme';
import { lineBreakToBr } from '../../../util';

type Props = {
  title: string;
  data1: any;
  data2: any;
};

function ParticipationContentItemColumn({ title, data1, data2 }: Props) {

  const { flexBoxDirection } = responsiveValue;
  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <Flex justify="space-between" pt="3" pb="3" direction={flexBoxDirection}>
      <Heading size="2xl" color="b.bk">{title}</Heading>
      <Box color="b.g" w={isMobile ? '100%' : '74%'}>
        <Flex justify="space-between" direction={flexBoxDirection}>
          <Box w={isMobile ? '100%' : '50%'} lineHeight="1.5" dangerouslySetInnerHTML={ {__html: lineBreakToBr(data1)} } />
          <Box w={isMobile ? '100%' : '50%'} lineHeight="1.5"  dangerouslySetInnerHTML={ {__html: lineBreakToBr(data2)} } />
        </Flex>
      </Box>
    </Flex>
  );
}

ParticipationContentItemColumn.defaultProps = {
};

export default ParticipationContentItemColumn;
